import { createComponent } from "@front/utils/alpine";
import { GoogleMapsAPI } from  '../services/gmaps';
import { GooglePlaceStore } from '../services/gplace';
import { buildFormData } from "@front/utils";
import prestashop from 'prestashop';

const MAP_ZOOM = 17;

type TStore = {
    id_store: string;
    name: string;
    placeId: string | undefined;
    lat: number;
    lng: number;
    distance: number;
};

type TStoreMapsOpts = {
    defaultLat: number;
    defaultLng: number;
};

type TPlaceResults = google.maps.places.PlaceResult[];
type TPlaceOpeningHoursPeriod = google.maps.places.PlaceOpeningHoursPeriod;
type TPlaceOpeningHoursPeriodArray = {
    [day:string] : TPlaceOpeningHoursPeriod[]
};

function makeMarker(map: google.maps.Map, store: TStore) {
    const { lat, lng } = store;
    const marker = new google.maps.Marker({
        position: { lat, lng },
        map,
    });

    marker.set('id_store', store.id_store);
    return marker;
}

async function getAndSetPlaceId(service: google.maps.places.PlacesService, store: TStore)
{
    const request = {
        location: {
            lat: store.lat,
            lng: store.lng,
        },
        radius: 500,
        query: store.name
    };

    let resolver: (
            value: TPlaceResults | PromiseLike<TPlaceResults> | null,
        ) => void;
        const query = new Promise<TPlaceResults | null>((resolve) => {
            resolver = resolve;
        });

    service.textSearch(
        request,
        (results, status) => {
            resolver(results);
        },
    );

    const places = await query;

    if(places && places.length > 0)
        return places[0]['place_id'];

    return '';
}

function addPlaceIdToStore(placeId: string, id_store: string) {
    const opts = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
        },
        body: buildFormData({
            ajax: '1',
            action: 'updateStorePlaceId',
            id_store: id_store,
            place_id: placeId,
        }),
    };

    fetch(prestashop.urls.pages.stores, opts);
}

export default createComponent(() => ({
    map: undefined as unknown as google.maps.Map,
    gstore: undefined as GooglePlaceStore | undefined,

    async init() {
        GoogleMapsAPI.load();
        await GoogleMapsAPI.ready;

        const meta = this.$el.querySelector<HTMLMetaElement>('meta[name^="store"]')
        if(!meta)
            return;

        const store = JSON.parse(meta.content) as TStore;
        const mapDiv = this.$el.querySelector<HTMLMetaElement>('div#mapholder')
        if(!store || !mapDiv)
            return;

        this.map = new google.maps.Map(mapDiv, {
            zoom: MAP_ZOOM,
            center: {
                lat: store.lat,
                lng: store.lng,
            },
        });

        const marker = makeMarker(this.map as google.maps.Map, store)

        if(! store.placeId) {
            const service = new google.maps.places.PlacesService(this.map);
            const response = await getAndSetPlaceId(service, store);

            store.placeId = await response;

            if(! store.placeId) {
                console.error('No placeId found for store', store);
                return;
            }
            addPlaceIdToStore(store.placeId, store.id_store);
        }
    },
}));
